const PRODUCTION_HOSTS = ['thetavern.fr', 'www.thetavern.fr'];
const STAGING_HOST = 'staging.thetavern.fr';

const getHostname = (runtimeWindow = window) =>
  runtimeWindow.location.hostname.toLowerCase();

export const getAppEnvironment = (runtimeWindow = window) => {
  const hostname = getHostname(runtimeWindow);

  if (hostname === STAGING_HOST) return 'staging';
  if (PRODUCTION_HOSTS.includes(hostname)) return 'production';
  return 'local';
};

export const isStagingEnvironment = (runtimeWindow = window) =>
  getAppEnvironment(runtimeWindow) === 'staging';

export const getAuthEnvironmentSwitchUrl = (runtimeWindow = window) => {
  const currentEnvironment = getAppEnvironment(runtimeWindow);
  const nextHostname =
    currentEnvironment === 'production'
      ? STAGING_HOST
      : currentEnvironment === 'staging'
        ? 'thetavern.fr'
        : '';

  if (!nextHostname) return '';

  const { pathname, search, hash } = runtimeWindow.location;
  return `https://${nextHostname}${pathname}${search}${hash}`;
};

export const openAuthEnvironmentSwitchUrl = (runtimeWindow = window) => {
  const switchUrl = getAuthEnvironmentSwitchUrl(runtimeWindow);
  if (!switchUrl) return false;

  runtimeWindow.location.assign(switchUrl);
  return true;
};
